import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class GtmService {
    getHeaderGtmTags(page: any) {
        const pageName = page?.[0]?.path ?? 'unknown';
        const capitalizedPageName = this.capitalize(pageName);
        // Define tags shared across multiple pages
        const headerGtmTags: Record<string, any> = {
            about_imSME: {
                event: `about_imsme_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View About imSME Button',
            },
            Product: {
                event: `business_financing_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View Business Financing Button',
            },
            Digital_Guarantee: {
                event: `digital_guarantee_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View Digital Guarantee Button',
            },
            Digital_Services: {
                event: `digital_services_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View Digital Services Button',
            },
            Grants: {
                event: `grants_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View Grants Button',
            },
            Insurance: {
                event: `insurance_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View Insurance Button',
            },
            whats_new: {
                event: `whats_new_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View What’s New Button',
            },
            jc3: {
                event: `jc3_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View JC3 Button',
            },
            Financing_Calculator: {
                event: `financing_calculator_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View Financing Calculator Button',
            },
            Partnership: {
                event: `partnership_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View Partnership Button',
            },
            ESG: {
                event: `esg_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View ESG Button',
            },
            IMSME_Icon_Top: {
                event: `imsme_top_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'IMSME Icon Button Top',
            },
            en: {
                event: `en_lang_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: `English Language Button`,
            },
            bm: {
                event: `bm_lang_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: `Malay Language Button`,
            },
            Login: {
                event: `login_button_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Login Button',
            },
            Get_Started: {
                event: `register_now_button_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Register Now Button',
            },
            Profile: {
                event: `profile_button_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Profile Button',
            },
            My_Application: {
                event: `my_applications_button_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'My Applications Button',
            },
            jc3_feedback_form: {
                event: `jc3_feedback_form_button_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'JC3 Feedback Form Button',
            },
            Log_Out: {
                event: `logout_button_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Logout Button',
            },
            Myknp: {
                event: 'myknp_mega_menu_hp_click',
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View MyKNP',
            },
            CGC_developmental_programme: {
                event: `CGC_developmental_programme_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View CGC Development Programme',
            },
            Faq: {
                event: `faq_mega_menu_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View FAQ',
            },
            Campaign: {
                event: 'campaign_button_faqp_click',
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View Campaign Button',
            },
        };

        // Format final GTM tag structure
        const gtmTags: Record<string, any> = {};
        for (const key in headerGtmTags) {
            const tag = headerGtmTags[key];
            gtmTags[key] = {
                event: tag.event,
                event_category: `${capitalizedPageName} Button`,
                event_label: tag.event_label,
            };
        }

        return gtmTags;
    }

    capitalize(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1).replace(/-/g, ' ');
    }

    getFooterGtmTags(page: any) {
        const pageName = page?.[0]?.path ?? 'unknown';

        const gtmTags = {
            IMSME_Icon: {
                event: `imsme_btm_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'IMSME Icon Home Button Bottom',
            },
            CGC_DIGI_ICON: {
                event: `cgc_digital_icon_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'CGC Digital Button',
            },
            CGC_ICON: {
                event: `cgc_icon_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'CGC Button',
            },
            Bank_Negara: {
                event: `bank_negara_icon_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Bank Negara Button',
            },
            SCSC: {
                event: `scsc_icon_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Securities Commision Malaysia Button',
            },
            JC3: {
                event: `jc3_icon_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'JC3 Button',
            },
            MY_KNP: {
                event: `my_knp_bottom_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View MyKNP Bottom Button',
            },
            CGC_DEV_PROG: {
                event: `cgcdevelopmentalprogramme_bottom_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'View CGC Development Programme Buttom Button',
            },
            Faq: {
                event: `faqs_btm_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'FAQs Bottom Button',
            },
            About: {
                event: `about_imsme_btm_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'About imSME Bottom Button',
            },
            Partnership: {
                event: `partnership_bottom_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Partnership Bottom Button',
            },
            ESG: {
                event: `esg_btm_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'ESG Bottom Button',
            },
            Contact_Us: {
                event: `contact_us_btm_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Contact Us Bottom Button',
            },
            Network_Facebook: {
                event: `facebook_icon_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Facebook Button',
            },
            Network_Instagram: {
                event: `instagram_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Instagram Button',
            },
            Network_Youtube: {
                event: `youtube_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Youtube Button',
            },
            Network_Linkedin: {
                event: `linkedln_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Linkedln Button',
            },
            Network_X: {
                event: `twitter_button_${pageName}_click`,
                event_category: `${this.capitalize(pageName)} Button`,
                event_label: 'Twitter Button',
            },
            Product: {
                event: `product_btm_button_${getEventName(page)}_click`,
                event_category: getCategoryName(page),
            },
            Insurance: {
                event: `insurance_btm_button_${getEventName(page)}_click`,
                event_category: getCategoryName(page),
            },
            Overview: {
                event: `product_overview_btm_button_${getEventName(
                    page
                )}_click`,
                event_category: getCategoryName(page),
            },
            Support: {
                event: `support_btm_button_${getEventName(page)}_click`,
                event_category: getCategoryName(page),
            },
            Email: {
                event: `email_button_${getEventName(page)}_click`,
                event_category: getCategoryName(page),
            },
        };
        return gtmTags;
    }

    sendEvent(
        eventId: string,
        eventCategory?: string,
        eventLabel?: string,
        track: string = 'track'
    ): void {
        const { gtag, dataLayer }: any = window;
        if (typeof gtag === 'function') {
            gtag('event', eventId, {
                ga_event_id: eventId,
                event_category: eventCategory,
                event_label: eventLabel,
                track: track,
            });
        }

        dataLayer.push({
            event: eventId,
            ga_event_id: eventId,
            event_category: eventCategory,
            event_label: eventLabel,
            track: track,
        });
    }

    sendClick(
        eventId: string,
        eventCategory?: string,
        eventLabel?: string,
        track: string = 'track'
    ): void {
        const { gtag }: any = window;
        if (typeof gtag === 'function') {
            gtag('event', 'gtm.click', {
                ga_event_id: eventId,
                event_category: eventCategory,
                event_label: eventLabel,
                track: track,
            });
        }
    }

    pushEvent(eventName: string, eventData: Record<string, any>): void {
        //@ts-ignore
        window.dataLayer.push({
            event: eventName,
            ...eventData,
        });
    }
}
function getEventName(page: any) {
    const combinedPath = page?.map?.((route) => route.path)?.join('/');
    if (combinedPath === 'grants/miti') return 'grants_miti';
    if (page === 'business-info') return 'bizp';
    if (page === 'corporate') return 'finp';
    if (page === 'matched-products') return 'matched_prodp';
    if (page === 'esg') return 'esg';
    if (page === 'cgc-developmental-programme') return 'dev_prog';
    if (page === 'insurance') return 'insp';
    if (page === 'sme') return 'msme_support';
    if (page === 'campaign') return 'camp';
    if (page === 'myknp') return 'myknp';
    if (page == 'home') {
        return 'hp';
    } else if (page == 'products') {
        return 'pp';
    } else if (page == 'check-eligibilty') {
        return 'cep';
    } else if (page == 'status') {
        return 'status_pg';
    } else if (page == 'faq') {
        return 'faqp';
    } else {
        return 'hp';
    }
}

function getCategoryName(page: any) {
    const combinedPath = page?.map?.((route) => route.path)?.join('/');
    if (combinedPath === 'grants/miti') return 'Grants MITI Page Button';
    if (page === 'business-info') return 'Business Information Page Button';
    if (page === 'corporate') return 'Financial Information Page Button';
    if (page === 'matched-products') return 'Matched Products Page Button';
    if (page === 'esg') return 'ESG Page Button';
    if (page === 'cgc-developmental-programme')
        return 'CGC Dev Programme Page Button';
    if (page === 'insurance') return 'Insurance Page Button';
    if (page === 'sme') return 'MSME Support Page Button';
    if (page === 'campaign') return 'Campaign Page Button';
    if (page === 'myknp') return 'MyKNP Page Button';
    if (page == 'home') {
        return 'Homepage Button';
    } else if (page == 'products') {
        return 'Products Page Button';
    } else if (page == 'insurance') {
        return 'Insurance Page Button';
    } else if (page == 'check-eligibilty') {
        return 'Check Eligibilty Page Button';
    } else if (page == 'status') {
        return 'Status Page Button';
    } else if (page == 'faq') {
        return 'FAQ Page Button';
    } else if (page == 'about-us') {
        return 'About Us Page Button';
    } else {
        return 'Homepage Button';
    }
}
